import {Typography, Par, Row, Col, Tooltip, Input} from "antd";
import {v4} from "uuid";
import {useEffect, useState} from "react";
export default function ProjectInfo({folderName, title, descriptions, version, planTitle, report, notes, showNotes, onChangeNotes}) {
    const fontFamily = window.location.pathname.includes('/app/report') ? 'Calibri' : 'Segoe UI'
    const fontSize = window.location.pathname.includes('/app/report') ? '11pt' : '9pt'

    const tooltip = () => {
        return (
            <div style={{whiteSpace: 'pre-line', height: 250, overflowY: 'auto'}}>
                {descriptions.filter(x => x.trim()).join('\n')}
            </div>
        )
    }

    const getLines = () => {
        if(!report)
            return descriptions.filter(x => x.trim())

        return descriptions.filter(x => x.trim())
    }

    return (
        <>
            {
                title && (
                    <table style={{fontFamily: fontFamily, fontSize: fontSize}}>
                        <tr>
                            <td style={{fontWeight: 'bold', width: 150}}>Folder Name:</td>
                            <td>{folderName}</td>
                        </tr>
                        <tr>
                            <td style={{fontWeight: 'bold'}}>Project Title:</td>
                            <td>{title}</td>
                        </tr>
                        <tr>
                            <td style={{fontWeight: 'bold'}}>HEC-RAS Version:</td>
                            <td>{version}</td>
                        </tr>
                        {
                            planTitle && (
                                <tr>
                                    <td style={{fontWeight: 'bold'}}>Plan Title:</td>
                                    <td>{planTitle}</td>
                                </tr>
                            )
                        }
                        <tr>
                            <td style={{fontWeight: 'bold', verticalAlign: 'top', paddingTop: !report ? 8 : '', marginBottom: !report ? 8 : '', display: 'table-cell'}}>
                                Project Description:
                            </td>
                            <td>
                                {
                                    getLines()?.length > 3
                                    ?
                                        (
                                            <Tooltip
                                                overlayStyle={{width: 400}}
                                                title={tooltip()}
                                                placement={'right'}
                                            >
                                                <div
                                                    style={{
                                                        whiteSpace: 'pre-line',
                                                        height: !report ? 72 : '',
                                                        paddingTop: !report ? 8 : '',
                                                        marginBottom: !report ? 8 : '',
                                                        overflow: 'hidden',
                                                        textOverflow: 'ellipsis'
                                                    }}
                                                >
                                                    {getLines().splice(0, 3).join('\n')}
                                                </div>
                                            </Tooltip>
                                        )
                                        :
                                        (
                                            <div
                                                style={{
                                                    whiteSpace: 'pre-line',
                                                    height: !report ? 72 : '',
                                                    paddingTop: !report ? 8 : '',
                                                    marginBottom: !report ? 8 : '',
                                                    overflow: 'hidden',
                                                    textOverflow: 'ellipsis'
                                                }}
                                            >
                                                {getLines().join('\n')}
                                            </div>
                                        )

                                }
                            </td>
                        </tr>
                        {
                            showNotes && (
                                <tr>
                                    <td style={{
                                        fontWeight: 'bold',
                                        verticalAlign: 'top',
                                        paddingTop: !report ? 8 : '',
                                        marginBottom: !report ? 8 : '',
                                        display: 'table-cell'
                                    }}>
                                        Project Notes:
                                    </td>
                                    <td>
                                        <textarea
                                            rows={1}
                                            style={{width: '100%'}}
                                            value={notes}
                                            onChange={(e) => onChangeNotes(e)}
                                        />
                                    </td>
                                </tr>
                            )
                        }
                    </table>
                )
            }
        </>
    )
}